/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Correspondence } from './correspondence';
import { Country } from './country';
import { UserGroupAttribute } from './userGroupAttribute';

export interface UserGroup { 
    id?: string;
    name?: string;
    fileId?: string;
    logoFileId?: string;
    logo?: any;
    parentId?: string;
    childGroups?: Array<UserGroup>;
    countryCode?: string;
    country?: Country;
    isMainAgency?: boolean;
    isMainConsularAgency?: boolean;
    isPublic?: boolean;
    userLimit?: number;
    internal?: boolean;
    visible?: boolean;
    installation?: string;
    createdDate?: Date;
    updatedDate?: Date;
    userGroupAttributes?: Array<UserGroupAttribute>;
    correspondenceReceivingAgencies?: Array<Correspondence>;
    correspondenceReceivingDepartments?: Array<Correspondence>;
}